import { AppliedFilterDevices, type Column, type Device } from "@/interfaces/types";
import { defineStore } from "pinia";
import { useI18n } from "vue-i18n";



export const laptopDataSenti = defineStore('deviceStore', {
    state: () => ({
      devices: [] as Device[],
      filteredDevices: [] as Device[],

      rows: 50,
      activeLicense: 0,
      usedLicense: 0,
      appliedFilter: {
        osNames: [],
        scanStatus: [],
        deviceName: "",
        lastActiveDate: [],
        lastFullDiskScanAt: [],
        scanStartedAt: [],
        scanAbortedAt: [],
        scanFinishedAt: [],
        registeredAt: [],
        deviceMode: [],
        networkStatus: [],
        coreCount: [] as number[],
        cpuCount: [] as number[],
        packageInstaller: [] as string[],
        osArch: [] as string[],
        cpuId: "",
        lastIpToMgmt: "",
        osRevision: "",
        activeThreats: "",
        agentVersion: "",
        operationalState: "",
        uuid: "",
      } as AppliedFilterDevices,

      freeSlot: {
        id: "",
        icon: "",
        computerName: "free slot",
        accountName: "",
    
        agentVersion: "",
        coreCount: 0,
        cpuCount: 0,
        cpuId: "",
    
        uuid: "",
    
        osArch: "",
        osName: "",
        modelName: "",
        installerType: "",
        osRevision: "",
    
        lastIpToMgmt: "",
        isActive:  false,
    
        scanStatus: "",
        fullDiskScanLastUpdatedAt: "",
        scanStartedAt: "",
        scanAbortedAt: "",
        scanFinishedAt: "",
        lastActiveDate: "",
        registeredAt: "",
    
        activeThreats: 0,
    
        networkStatus: "",
        operationalState: "",
        operationalStateExpiration: "",
    
        scanStatusToggle: false,
        isDecommissioned: false,
        selected: false,
        isFreeSlot: true
      } as Device,

      scanStatusOptions: [
        {value: "started", translation: "Started"},
        {value: "aborted", translation: "Aborted"},
        {value: "finished", translation: "Finished"},
        {value: "turnOn", translation: "Turn it on"}
      ],

      networkStatuses: [
        {value: "connected", translation: "Connected"},
        {value: "disconnected", translation: "Disconnected"},
        {value: "connecting", translation: "Connecting.."},
        {value: "disconnecting", translation: "Disconnecting.."},
      ],

      deviceModeOptions: [
        {value: true, translation: "On"},
        {value: false, translation: "Off"}
      ],


        columns: [
            { field: 'icon', header: 'Scan' },
            { field: 'computerName', header: 'Device name' },
            { field: 'lastActiveDate', header: 'Last active date' },
            
            { field: 'scanStatus', header: 'Scan status' },
            { field: 'fullDiskScanLastUpdatedAt', header: 'Last full disk scan' },
            { field: 'scanStartedAt', header: 'Scan started' },
            { field: 'scanAbortedAt', header: 'Scan aborted' },
            { field: 'scanFinishedAt', header: 'Scan finished' },
            { field: 'registeredAt', header: 'Registration' },
            
            { field: 'isActive', header: 'Device Mode' },
            { field: 'networkStatus', header: 'Sentinelone network' },
            
            { field: 'coreCount', header: 'Core count' },
            { field: 'cpuCount', header: 'CPU count' },
            { field: 'cpuId', header: 'Processor' },
            { field: 'lastIpToMgmt', header: 'IP address' },
            { field: 'installerType', header: 'Pkg installer type' },
            { field: 'osArch', header: 'Architecture' },
            { field: 'osName', header: 'OS' },
            { field: 'osRevision', header: 'OS detail' },
            // { field: 'uuid', header: 'uuid' },
            
            { field: 'agentVersion', header: 'Agent V.' },
            
            { field: 'operationalState', header: 'Antivirus active' },
            { field: 'activeThreats', header: 'Active threats' },
        ] as Column[],


        selectedColumns: [
            { field: 'icon', header: 'Scan' },
            { field: 'computerName', header: 'Device name' },
            { field: 'lastActiveDate', header: 'Last active date' },
            
            { field: 'scanStatus', header: 'Scan status' },
            { field: 'fullDiskScanLastUpdatedAt', header: 'Last full disk scan' },
            { field: 'scanStartedAt', header: 'Scan started' },
            { field: 'scanAbortedAt', header: 'Scan aborted' },
            { field: 'scanFinishedAt', header: 'Scan finished' },
            { field: 'registeredAt', header: 'Registration' },
            
            { field: 'isActive', header: 'Device Mode' },
            { field: 'networkStatus', header: 'Sentinelone network' },
            
            { field: 'coreCount', header: 'Core count' },
            { field: 'cpuCount', header: 'CPU count' },
            { field: 'cpuId', header: 'Processor' },
            { field: 'lastIpToMgmt', header: 'IP address' },
            { field: 'installerType', header: 'Pkg installer type' },
            { field: 'osArch', header: 'Architecture' },
            { field: 'osName', header: 'OS' },
            { field: 'osRevision', header: 'OS detail' },
            // { field: 'uuid', header: 'uuid' },
            
            { field: 'agentVersion', header: 'Agent V.' },
            
            { field: 'operationalState', header: 'Antivirus active' },
            { field: 'activeThreats', header: 'Active threats' },
        ] as Column[],


        groupedColumns: [
          {
            label: 'User',
            items: [
              { field: 'computerName', header: 'Device name' },
            ]
          },
          {
            label: 'Scan',
            items: [
              { field: 'scanStatus', header: 'Scan status' },
            ]
          },
          {
            label: 'Network',
            items: [
              { field: 'isActive', header: 'Device mode' },
              { field: 'networkStatus', header: 'Network status' },
            ]
          },
          {
            label: 'Date',
            items: [
              { field: 'registeredAt', header: 'Registration' },
              { field: 'fullDiskScanLastUpdatedAt', header: 'Last full disk scan' },
              { field: 'scanStartedAt', header: 'Scan started' },
              { field: 'scanAbortedAt', header: 'Scan aborted' },
              { field: 'scanFinishedAt', header: 'Scan finished' },
              { field: 'lastActiveDate', header: 'Last active date' },

            ]
          },
          {
            label: 'Device detail',
            items: [
              { field: 'coreCount', header: 'Core count' },
              { field: 'cpuCount', header: 'CPU count' },
              { field: 'cpuId', header: 'Processor' },
              { field: 'lastIpToMgmt', header: 'IP address' },
              { field: 'installerType', header: 'Pkg installer type' },
              { field: 'osArch', header: 'Architecture' },
              { field: 'osName', header: 'OS' },
              { field: 'osRevision', header: 'OS detail' },
              // { field: 'uuid', header: 'uuid' },
              { field: 'modelName', header: 'Model' },
            ]
          },
          {
            label: 'Agent',
            items: [
              { field: 'agentVersion', header: 'Agent V.' },
            ]
          },
          {
            label: 'Threat',
            items: [
              { field: 'operationalState', header: 'Antivirus active' },
              { field: 'activeThreats', header: 'Active threats' },
            ]
          },
        ]
    }),
  
    actions: {
      clearCache() {
        const { t } = useI18n();

        this.freeSlot = {
          id: "",
          icon: "",
          computerName: t('devices.freeSlot'),
          accountName: "",
      
          agentVersion: "",
          coreCount: 0,
          cpuCount: 0,
          cpuId: "",
      
          uuid: "",
      
          osArch: "",
          osName: "",
          modelName: "",
          installerType: "",
          osRevision: "",
      
          lastIpToMgmt: "",
          isActive:  false,
      
          scanStatus: "",
          fullDiskScanLastUpdatedAt: "",
          scanStartedAt: "",
          scanAbortedAt: "",
          scanFinishedAt: "",
          lastActiveDate: "",
          registeredAt: "",
      
          activeThreats: 0,
      
          networkStatus: "",
          operationalState: "",
          operationalStateExpiration: "",
      
          scanStatusToggle: false,
          isDecommissioned: false,
          selected: false,
          isFreeSlot: true,
          loadingUninstall: false
        }
      },
      initializeColumnsDevices(t: (key: string) => string){
        
        this.groupedColumns = [
          {
            label: t('labelGroupedColumns.user'),
            items: [
              { field: 'computerName', header: t('tableColumns.deviceName') },
            ],
          },
          {
            label: t('labelGroupedColumns.scan'),
            items: [
              { field: 'scanStatus', header: t('tableColumns.scanStatus') },
            ],
          },
          {
            label: t('labelGroupedColumns.network'),
            items: [
              { field: 'isActive', header: t('tableColumns.isActive') },
              { field: 'networkStatus', header: t('tableColumns.networkStatus') },
            ],
          },
          {
            label: t('labelGroupedColumns.date'),
            items: [
              { field: 'registeredAt', header: t('tableColumns.registration') },
              { field: 'fullDiskScanLastUpdatedAt', header: t('tableColumns.fullDiskScan') },
              { field: 'scanStartedAt', header: t('tableColumns.scanStarted') },
              { field: 'scanAbortedAt', header: t('tableColumns.scanAborted') },
              { field: 'scanFinishedAt', header: t('tableColumns.scanFinished') },
              { field: 'lastActiveDate', header: t('tableColumns.lastActiveDate') },
            ],
          },
          {
            label: t('labelGroupedColumns.deviceDetail'),
            items: [
              { field: 'coreCount', header: t('tableColumns.coreCount') },
              { field: 'cpuCount', header: t('tableColumns.cpuCount') },
              { field: 'cpuId', header: t('tableColumns.cpuId') },
              { field: 'lastIpToMgmt', header: t('tableColumns.lastIpToMgmt') },
              { field: 'installerType', header: t('tableColumns.installerType') },
              { field: 'osArch', header: t('tableColumns.osArch') },
              { field: 'osName', header: t('tableColumns.osName') },
              { field: 'osRevision', header: t('tableColumns.osRevision') },
              // { field: 'uuid', header: t('tableColumns.uuid') },
              { field: 'modelName', header: t('tableColumns.modelName') },
            ],
          },
          {
            label: t('labelGroupedColumns.agent'),
            items: [
              { field: 'agentVersion', header: t('tableColumns.agentVersion') },
            ],
          },
          {
            label: t('labelGroupedColumns.threat'),
            items: [
              { field: 'operationalState', header: t('tableColumns.operationalState') },
              { field: 'activeThreats', header: t('tableColumns.activeThreats') },
            ],
          },
        ]
        const selectedFields = this.selectedColumns.map(col => col.field);
        this.selectedColumns = this.groupedColumns
          .flatMap(group => group.items)
          .filter(col => selectedFields.includes(col.field));
      },
      onToggle(val: any) {
        this.selectedColumns = this.columns.filter(col => val.includes(col));
      },
      selectIcon(name: string): string {
        return name.includes("nux") || name.includes('untu') ? "mdi mdi-linux" : name.includes("ndow") ? "mdi mdi-microsoft-windows" : "mdi mdi-apple";
      },

      translateFilter(t: (key: string) => string){
        this.scanStatusOptions.forEach(scan => {
          scan.translation = t(`devices.${scan.value}`)
        })

        this.deviceModeOptions.forEach(dev => {
          dev.translation = t(`devices.${dev.value}`)
        })

        this.networkStatuses.forEach(dev => {
          dev.translation = t(`devices.${dev.value}`)
        })

        this.filteredDevices.forEach(dev => {
          if(dev.isFreeSlot){
            dev.computerName = t('devices.freeSlot')
          }
        })
      },

      validateDates() {
        return this.validateDate(this.appliedFilter.lastActiveDate) ||
        this.validateDate(this.appliedFilter.lastFullDiskScanAt) ||
        this.validateDate(this.appliedFilter.scanAbortedAt) ||
        this.validateDate(this.appliedFilter.scanStartedAt) ||
        this.validateDate(this.appliedFilter.scanFinishedAt) ||
        this.validateDate(this.appliedFilter.registeredAt)
      },

      validateDate(date: Date[]): boolean {
        if(!date) return false
        return date[0] && !date[1]
      },

      applyFilter(){
        this.filteredDevices = [...this.devices]
    
        if(this.appliedFilter.osNames.length !== 0)
            this.filteredDevices = this.filteredDevices.filter(dev => this.appliedFilter.osNames.map(d => d.name).includes(dev.osName))
        if(this.appliedFilter.scanStatus.length !== 0)
            this.filteredDevices = this.filteredDevices.filter(dev => this.appliedFilter.scanStatus.map(d => d.value).includes(dev.scanStatus))
        if(this.appliedFilter.deviceName.length !== 0)
            this.filteredDevices = this.filteredDevices.filter(dev => dev.computerName.toLowerCase().includes(this.appliedFilter.deviceName.toLowerCase()))
        if(this.appliedFilter.lastActiveDate?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => {
                const deviceDate = new Date(dev.lastActiveDate);
                deviceDate.setHours(0, 0, 0, 0);
                const startDate = new Date(this.appliedFilter.lastActiveDate[0]);
                this.appliedFilter.lastActiveDate[0] = startDate
                startDate.setHours(0, 0, 0, 0);
                const endDate = new Date(this.appliedFilter.lastActiveDate[1]);
                this.appliedFilter.lastActiveDate[1] = endDate
                endDate.setHours(0, 0, 0, 0);
                return deviceDate >= startDate && deviceDate <= endDate;
            })
        }
        if(this.appliedFilter.lastFullDiskScanAt?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => {
                const deviceDate = new Date(dev.fullDiskScanLastUpdatedAt);
                deviceDate.setHours(0, 0, 0, 0);
                const startDate = new Date(this.appliedFilter.lastFullDiskScanAt[0]);
                this.appliedFilter.lastFullDiskScanAt[0] = startDate
                startDate.setHours(0, 0, 0, 0);
                const endDate = new Date(this.appliedFilter.lastFullDiskScanAt[1]);
                this.appliedFilter.lastFullDiskScanAt[1] = endDate
                endDate.setHours(0, 0, 0, 0);
                return deviceDate >= startDate && deviceDate <= endDate;
            })
        }
        if(this.appliedFilter.scanStartedAt?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => {
                const deviceDate = new Date(dev.scanStartedAt);
                deviceDate.setHours(0, 0, 0, 0);
                const startDate = new Date(this.appliedFilter.scanStartedAt[0]);
                this.appliedFilter.scanStartedAt[0] = startDate
                startDate.setHours(0, 0, 0, 0);
                const endDate = new Date(this.appliedFilter.scanStartedAt[1]);
                this.appliedFilter.scanStartedAt[1] = endDate
                endDate.setHours(0, 0, 0, 0);
                return deviceDate >= startDate && deviceDate <= endDate;
            })
        }
        if(this.appliedFilter.scanAbortedAt?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => {
                const deviceDate = new Date(dev.scanAbortedAt);
                deviceDate.setHours(0, 0, 0, 0);
                const startDate = new Date(this.appliedFilter.scanAbortedAt[0]);
                this.appliedFilter.scanAbortedAt[0] = startDate
                startDate.setHours(0, 0, 0, 0);
                const endDate = new Date(this.appliedFilter.scanAbortedAt[1]);
                this.appliedFilter.scanAbortedAt[1] = endDate
                endDate.setHours(0, 0, 0, 0);
                return deviceDate >= startDate && deviceDate <= endDate;
            })
        }
        if(this.appliedFilter.scanFinishedAt?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => {
                const deviceDate = new Date(dev.scanFinishedAt);
                deviceDate.setHours(0, 0, 0, 0);
                const startDate = new Date(this.appliedFilter.scanFinishedAt[0]);
                this.appliedFilter.scanFinishedAt[0] = startDate
                startDate.setHours(0, 0, 0, 0);
                const endDate = new Date(this.appliedFilter.scanFinishedAt[1]);
                this.appliedFilter.scanFinishedAt[1] = endDate
                endDate.setHours(0, 0, 0, 0);
                return deviceDate >= startDate && deviceDate <= endDate;
            })
        }
        if(this.appliedFilter.registeredAt?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => {
                const deviceDate = new Date(dev.registeredAt);
                deviceDate.setHours(0, 0, 0, 0);
                const startDate = new Date(this.appliedFilter.registeredAt[0]);
                this.appliedFilter.registeredAt[0] = startDate
                startDate.setHours(0, 0, 0, 0);
                const endDate = new Date(this.appliedFilter.registeredAt[1]);
                this.appliedFilter.registeredAt[1] = endDate
                endDate.setHours(0, 0, 0, 0);
                return deviceDate >= startDate && deviceDate <= endDate;
            })
        }
        if(this.appliedFilter.deviceMode?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => this.appliedFilter.deviceMode.map(d => d.value).includes(dev.isActive))
        }
        if(this.appliedFilter.networkStatus?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => this.appliedFilter.networkStatus.map(d => d.value.toLowerCase()).includes(dev.networkStatus.toLowerCase()))
        }
        if(this.appliedFilter.coreCount?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => this.appliedFilter.coreCount.includes(dev.coreCount))
        }
        if(this.appliedFilter.cpuCount?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => this.appliedFilter.cpuCount.includes(dev.cpuCount))
        }
        if(this.appliedFilter.packageInstaller?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => this.appliedFilter.packageInstaller.map(d => d.toLowerCase()).includes(dev.installerType.toLowerCase()))
        }
        if(this.appliedFilter.osArch?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => this.appliedFilter.osArch.map(d => d.toLowerCase()).includes(dev.osArch.toLowerCase()))
        }
        if(this.appliedFilter.cpuId?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => dev.cpuId.includes(this.appliedFilter.cpuId))
        }
        if(this.appliedFilter.lastIpToMgmt?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => dev.lastIpToMgmt.includes(this.appliedFilter.lastIpToMgmt))
        }
        if(this.appliedFilter.osRevision?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => dev.osRevision.includes(this.appliedFilter.osRevision))
        }
        if(this.appliedFilter.activeThreats?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => dev.activeThreats.toString().includes(this.appliedFilter.activeThreats))
        }
        if(this.appliedFilter.agentVersion?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => dev.agentVersion.includes(this.appliedFilter.agentVersion))
        }
        if(this.appliedFilter.operationalState?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => dev.operationalState.includes(this.appliedFilter.operationalState))
        }
        if(this.appliedFilter.uuid?.length){
            this.filteredDevices = this.filteredDevices.filter(dev => dev.uuid.includes(this.appliedFilter.uuid))
        }

        for(let i=1; i<=this.activeLicense-this.usedLicense; i++){
          this.filteredDevices.push({ ...this.freeSlot })
        }
      },

      clearFilter() {
        this.appliedFilter.osNames = []
        this.appliedFilter.scanStatus = []
        this.appliedFilter.deviceName = ""
        this.appliedFilter.lastActiveDate = []
        this.appliedFilter.lastFullDiskScanAt = []
        this.appliedFilter.scanAbortedAt = []
        this.appliedFilter.scanStartedAt = []
        this.appliedFilter.scanFinishedAt = []
        this.appliedFilter.registeredAt = []
        this.appliedFilter.deviceMode = []
        this.appliedFilter.networkStatus = []
        this.appliedFilter.coreCount = []
        this.appliedFilter.cpuCount = []
        this.appliedFilter.packageInstaller = []
        this.appliedFilter.osArch = []
        this.appliedFilter.cpuId = ""
        this.appliedFilter.lastIpToMgmt = ""
        this.appliedFilter.osRevision = ""
        this.appliedFilter.activeThreats = ""
        this.appliedFilter.uuid = ""
        this.appliedFilter.agentVersion = ""
        this.appliedFilter.operationalState = ""
    
    
        this.filteredDevices = [...this.devices]
        for(let i=1; i<=this.activeLicense-this.usedLicense; i++){
          this.filteredDevices.push({ ...this.freeSlot })
        }
      },

      emptyFilter() {
        return this.appliedFilter.osNames.length === 0 &&
        this.appliedFilter.scanStatus.length === 0 &&
        this.appliedFilter.deviceName.length === 0 &&
        this.appliedFilter.lastActiveDate?.length === 0 &&
        this.appliedFilter.lastFullDiskScanAt?.length === 0 &&
        this.appliedFilter.scanStartedAt?.length === 0 &&
        this.appliedFilter.scanAbortedAt?.length === 0 &&
        this.appliedFilter.scanFinishedAt?.length === 0 &&
        this.appliedFilter.registeredAt?.length === 0 &&
        this.appliedFilter.deviceMode?.length === 0 &&
        this.appliedFilter.networkStatus?.length === 0 &&
        this.appliedFilter.coreCount?.length === 0 &&
        this.appliedFilter.cpuCount?.length === 0 &&
        this.appliedFilter.packageInstaller?.length === 0 &&
        this.appliedFilter.osArch?.length === 0 &&
        this.appliedFilter.cpuId?.length === 0 &&
        this.appliedFilter.lastIpToMgmt?.length === 0 &&
        this.appliedFilter.osRevision?.length === 0 &&
        this.appliedFilter.activeThreats?.length === 0 &&
        this.appliedFilter.operationalState?.length === 0 &&
        this.appliedFilter.uuid?.length === 0 &&
        this.appliedFilter.agentVersion?.length === 0 
      }
    },
  
    persist: true
  });
  